// extracted by mini-css-extract-plugin
module.exports = {"terms":"pc_terms__GW730","main":"pc_main__wp8Om"};